module.exports = __webpack_public_path__ + "img/yom_no.d49b6d09.png";